var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C14.6969 0 9.60625 2.10844 5.85938 5.85781C2.10863 9.60868 0.00103897 14.6956 0 20C0 25.3022 2.10938 30.3928 5.85938 34.1422C9.60625 37.8916 14.6969 40 20 40C25.3031 40 30.3937 37.8916 34.1406 34.1422C37.8906 30.3928 40 25.3022 40 20C40 14.6978 37.8906 9.60719 34.1406 5.85781C30.3937 2.10844 25.3031 0 20 0Z",
    fill: "url(#paint0_linear_772_38247)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0534 19.7897C14.8846 17.2497 18.7721 15.575 20.7159 14.7659C26.2721 12.4556 27.4253 12.0544 28.1784 12.0408C28.344 12.0381 28.7128 12.079 28.9534 12.2736C29.1534 12.4376 29.2096 12.6595 29.2378 12.8153C29.2628 12.9709 29.2971 13.3256 29.269 13.6025C28.969 16.765 27.6659 24.4394 27.0034 27.9815C26.7253 29.4803 26.1721 29.9828 25.6378 30.0319C24.4753 30.1387 23.594 29.2644 22.469 28.5272C20.7096 27.3731 19.7159 26.655 18.0065 25.529C16.0315 24.2278 17.3128 23.5125 18.4378 22.3437C18.7315 22.0378 23.8503 17.3831 23.9471 16.9609C23.9596 16.9081 23.9721 16.7112 23.8534 16.6075C23.7378 16.5034 23.5659 16.539 23.4409 16.5672C23.2628 16.6072 20.4534 18.4659 15.0034 22.1431C14.2065 22.6912 13.4846 22.9584 12.8346 22.9444C12.1221 22.929 10.7471 22.5406 9.72527 22.2087C8.47527 21.8015 7.4784 21.5862 7.5659 20.8947C7.60965 20.5347 8.10652 20.1662 9.0534 19.7897Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_772_38247",
    x1: 2000,
    y1: 0,
    x2: 2000,
    y2: 4000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.c51a228c3295441b4554dbe51aa71fa3.svg";
export { ForwardRef as ReactComponent };